import * as types from '../../../actions';
const initialState = {
    items: [],
    status:0,
    item:{
        id:'',
        name:'',
    },
    activity:'',
    count:0,
    errorData:''    
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {
        case types.CLIENT_CATEGORY_MASTER_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data.results ? response.data.results : response.data,
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_LIST_SUCCESS,
                    count:response.data.count
                };
            }else{
                return {
                    ...state,
                    status: response.status,     
                    activity:types.CLIENT_CATEGORY_MASTER_LIST_ERROR,                            
                };
            }       

        case types.CLIENT_CATEGORY_MASTER_ADD_SUCCESS:
            // FOR ALREADY ADDED CATEGORY, IF RESPONSE IS 200, WE NEED TO CHECK THE MESSAGE IS "already_exist"
            // {"status":409,"message":"already_exist"}
            if(response?.data?.message && response.data.message=="already_exist") { 
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity: types.CLIENT_CATEGORY_MASTER_ADD_ERROR,
                }
            }
            else 
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_ADD_SUCCESS,
                }   
            }else{
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_ADD_ERROR,
                }   
            }
        case types.CLIENT_CATEGORY_MASTER_EDIT_SUCCESS:     
            if(response.status===200){     
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        name: response.data.name
                    },
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_EDIT_SUCCESS,               
                }     
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_EDIT_ERROR,         
                }   
            }  
       
        case types.CLIENT_CATEGORY_MASTER_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_UPDATE_SUCCESS,         
                }    
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_UPDATE_ERROR, 
                    errorData: response.data,        
                }    
            }       

        case types.CLIENT_CATEGORY_MASTER_DELETE_SUCCESS:
            const id = response.data.id;     
            if(response.status===200){
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),               
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_DELETE_SUCCESS,   
                }       
    
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_MASTER_DELETE_ERROR,  
                    errorData: response.data, 
                }       
    
            }           
            
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name:''
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
    }
  };